import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LogistTimeManagementClientIdService } from './logist-time-management-client-id.service';

@Injectable()
export class LogistTimeManagementClientIdInterceptor implements HttpInterceptor {
  private readonly clientIdService = inject(
    LogistTimeManagementClientIdService,
  );

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const isMutation = !['GET', 'HEAD', 'OPTIONS'].includes(request.method);
    const isTmlRequest = request.url.includes('/logistic/time-management');

    return next.handle(
      isMutation && isTmlRequest
        ? request.clone({
            setHeaders: {
              'x-ltm-client-id': this.clientIdService.id,
            },
          })
        : request,
    );
  }
}
